import { render, staticRenderFns } from "./AlertList2.vue?vue&type=template&id=88eee3c4&"
import script from "./AlertList2.vue?vue&type=script&lang=js&"
export * from "./AlertList2.vue?vue&type=script&lang=js&"
import style0 from "./AlertList2.vue?vue&type=style&index=0&id=88eee3c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports